module.exports = require("css-element-queries/src/ResizeSensor");